

import React, { useState } from 'react'
import { Form, Card, Row, Col, Checkbox, Button, InputNumber, Input, message, DatePicker } from 'antd';
import Footer from '../../../../../components/common/Footer';
import PageHeading from '../../../../../components/common/PageHeading';
import RightBar from '../../../../../components/common/RightBar';
import { InboxOutlined } from '@ant-design/icons';
import { Select } from 'antd'; import SubHeading from '../../../../../components/common/SubHeading';
import Dragger from 'antd/es/upload/Dragger';
import MultiSelect from '../../../../../components/common/MultiSelect';
import { guestfilterinboxby } from '../../../../../data/guestcards';
const { Option } = Select;

const LockBox = () => {

    const [showEmail, setShowEmail] = useState(false)
    const onFinish = (values) => {
        console.log('Form values:', values);
    };
    const GeneralSettingsRightBar = [];

    const FirstCheckBoxValue = (e) => {
        setShowEmail(e.target.checked)
    }
    const props = {
        name: 'file',
        multiple: true,
        action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };

    return (
        <>


            <Form layout='vertical'>
                <PageHeading heading="Lockbox" />
                <SubHeading subHeading="Download Your Validation File" />

                <Row className="cardBoxShadow" title="General Texting Settings" >
                    <Col style={{ margin: '10px 0px', fontWeight: "500", fontSize: "1em", lineHeight: 1.5 }}>
                        Your validation file contains your unique IDs which are required for upload.
                    </Col>
                </Row>
                <Row style={{}}>

                    <Col span={1} style={{ marginBottom: '10px' }}>

                    </Col>
                    <Col span={4} style={{ marginBottom: '10px', fontWeight: "200", fontSize: "0.9em", marginBottom: 12, lineHeight: 1.5 }}>
                        <label style={{ color: 'gray' }}>Properties or Associations</label>
                    </Col>
                    <Col span={10}>

                        <Form.Item >
                            <MultiSelect style={{ color: 'gray', fontWeight: "200", fontSize: "0.7em", lineHeight: 1.5 }}
                                options={guestfilterinboxby}
                                placeholder="Search by propert group, portfolio or owner"
                                className="filter-select"
                            />

                        </Form.Item>
                    </Col>
                </Row>
                <Row style={{}}>

                    <Col span={5}>
                    </Col>
                    <Col span={10} style={{ marginBottom: '10px' }}>
                        <label style={{ color: 'gray', fontWeight: "200", fontSize: "0.8em", lineHeight: 1.5 }}>By default all properties and associations will be included.</label>
                    </Col>

                </Row>
                <Row style={{}}>

                    <Col span={1} ></Col>
                    <Col span={4} style={{ marginBottom: '10px' }}>
                        <label style={{ color: 'gray', display: 'flex', justifyContent: 'center', textAlign: 'center', fontWeight: "200", fontSize: "0.9em", lineHeight: 1.5 }}>Validation File Type</label>
                    </Col>
                    <Col span={10}>
                        <Select style={{ width: '100%' }} dropdownStyle={{ zIndex: 99999 }}>
                            
                        </Select>
                    </Col>


                </Row>
                <Row className="cardBoxShadow" title="General Texting Settings" >
                    <Col style={{ margin: '10px' }}>
                        <Button style={{ marginTop: '10px' }} >Download Validation File</Button>
                    </Col>
                </Row>

                <PageHeading />
                <SubHeading subHeading="Upload Your Lockbox File" />

                <Row>
                    <Col span={15} style={{ margin: '10px 0px 5px 0px', fontWeight: "200", fontSize: "0.9em", lineHeight: 1.5 }}>

                        <Form.Item name="date-picker" label="Date" rules={[{ required: true }]}
                        >
                            <DatePicker style={{ width: 300 }} />
                        </Form.Item>

                    </Col>
                    <Col span={15} style={{ margin: '10px 0px' }}>
                        <Dragger style={{ padding: 8 }}>
                            <InboxOutlined />
                            <span style={{ marginLeft: 8, fontWeight: "500", fontSize: "1em", lineHeight: 1.5 }} >Drag Files Here <br></br>or
                                <br></br><Button>Choose Files to Upload</Button></span>
                        </Dragger>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="form-action page-actions-container">
                            <Button type="primary" htmlType="sumbit">Submit</Button>
                            <Button >Cancel</Button>
                        </div></Col>
                </Row>
            </Form>


            <div className="RightSidebar">
                <RightBar RightBarData={GeneralSettingsRightBar} />
            </div>

        </>
    )
}

export default LockBox;


